<template>
  <v-card
    class=" pa-0 ma-0 justify-center preview-container"
    flat
  >
    <v-card-title
      class="pb-2 preview"
      :class="{'px-4': !fromSummary, 'pl-1': fromSummary}"
      v-show="editedBusinessDetails"
    >
      <v-layout
        justify-center
      >
        <v-flex
          xs12
          v-if="adPreviewMode"
        >
          <facebook-instagram-ad-preview
            :facebook-ad-details="facebookAdDetails"
            :extracted-creative-details="extractedCreativeDetails"
            :template="template"
            :show-facebook-preview="true"
            :show-instagram-preview="true"
          />
        </v-flex>
        <v-flex
          :class="{ 'xs10': !$vuetify.breakpoint.smAndDown && !fromSummary, 'xs12': $vuetify.breakpoint.smAndDown , 'xs12': fromSummary , 'separator': fromSummary}"
          v-else
        >
          <edit-ad-details :edited-business-details="editedBusinessDetails" :for-summary="fromSummary" @isBtnDisabled="updateIsBtnDisabled" />
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-spacer />
    <v-card-actions class="py-0 pb-2 card-actions">
      <v-flex xs12 :class="{'ml-3':!$vuetify.breakpoint.xsOnly}">
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex :class="{ 'shrink mr-2': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              color="primary"
              @click="closeAdDetailsDialog(true, false)"
              :disabled="isBtnDisabled"
            >
              <span class="text-capitalize" v-if="showAdPreviewButton">{{ $t('message.preview') }} </span>  <span v-else class="text-capitalize"> {{ $t('message.done') }}</span>
            </v-btn>
          </v-flex>
          <v-flex :class="{ 'shrink ml-2': !$vuetify.breakpoint.xsOnly, 'xs12 mb-2': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              color="primary"
              outline
              v-if="!$vuetify.breakpoint.xsOnly"
              @click="closeAdDetailsDialog(false, true)"
            >
              {{ $t('message.bizgainOnboarding.discard') }}
            </v-btn>
            <span class="text-xs-center font-bold" @click="closeAdDetailsDialog(false, true)" v-else>
              <a
                class="text-xs-center my-1"
              > {{ $t('message.bizgainOnboarding.discard') }}</a>
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  VCard,
  VCardTitle,
  VCardActions,
  VLayout,
  VFlex,
  VSpacer
} from 'vuetify/lib';
import FacebookInstagramAdPreview from 'Features/bizgainOnboarding/pages/imageCreativesAdPreview/components/FacebookInstagramAdPreview';
import EditAdDetails from 'Features/bizgainOnboarding/pages/imageCreativesAdDetailsEdit/components/Edit';
export default {
  components: {
    VCard,
    VCardTitle,
    VCardActions,
    VLayout,
    VFlex,
    FacebookInstagramAdPreview,
    EditAdDetails,
    VSpacer
  },
  props: {
    editedBusinessDetails: {
      type: Object,
      default: null
    },
    extractedCreativeDetails: {
      type: Object,
      default: null
    },
    facebookAdDetails: {
      type: Object,
      default: null
    },
    template: {
      type: Object,
      default: null
    },
    fromSummary: {
      type: Boolean,
      default: false
    }
  },
  created(){
    this.initialEditedBusinessDetails = JSON.parse(JSON.stringify(this.editedBusinessDetails))
  },
  data() {
    return {
      isBtnDisabled: false,
      adPreviewMode: false,
      initialEditedBusinessDetails: null
    }
  },
  computed: {
    showAdPreviewButton(){
      return this.$vuetify.breakpoint.smAndDown && !this.adPreviewMode;
    }
  },
  methods: {
    updateIsBtnDisabled(isBtnDisabled){
      this.isBtnDisabled = isBtnDisabled;
      this.$emit('isBtnDisabled', isBtnDisabled);
    },
    discardChanges(){
      this.closeDialog();
      this.$emit('details-discarded', JSON.parse(JSON.stringify(this.initialEditedBusinessDetails)));
    },
    closeAdDetailsDialog(isEditDone, isDiscarded){
      if(isDiscarded){
        this.discardChanges();
      }
      this.$emit('updateFacebookAdDetails');
      if(this.fromSummary && isEditDone && (this.adPreviewMode || !this.$vuetify.breakpoint.smAndDown)){
        this.$emit('updateFacebookAdDetails');
        this.$emit('updateBusinesssandCreativeDetails');
      }
      if(this.$vuetify.breakpoint.smAndDown && !this.adPreviewMode && isEditDone){
        this.adPreviewMode = true;
      }else{
        this.closeDialog();
      }
    },
    closeDialog(){
      this.$emit('closeDialog', true);
    }
  }
}
</script>

<style lang="scss" scoped>
  .preview-container{
    align-items: center;
    display: grid;
  }
  .preview{
    overflow: hidden;
  }
  .card-actions {
    // position: absolute;
    // bottom: 0;
    // width: 100%;
  }

  .font-bold{
    font-weight: 500;
  }
  .separator{
  border-bottom: 1px solid #aaaaaa;
}
</style>